import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditUnit = () => {
  const location = useLocation();
  const departmentToEdit = location.state?.unit;
  const id = useParams();
  const [formValues, setFormValues] = useState({
    department_id: "",
    courseCategory_id: "",
    course_id: "",
    chapter_id: "",
    unitname: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [course, setCourse] = useState([]);
  const [chapter, setChapter] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const navigate = useNavigate();

  useEffect(() => {
    // console.log("unit to editt: ", departmentToEdit);
    if (departmentToEdit) {
      setFormValues({
        department_id: departmentToEdit.department._id,
        courseCategory_id: departmentToEdit.courseCategory_id,
        course_id: departmentToEdit.course_id,
        chapter_id: departmentToEdit.chapter_id,
        unitname: departmentToEdit.unitname,
      });
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No unit data found.");
      setLoading(false);
    }
  }, [departmentToEdit]);

  useEffect(() => {
    const fetchdepartment = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setDepartments(response?.data.data);
        // console.log("departments", response?.data.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchdepartment();
  }, []);

  useEffect(() => {
    const fetchCourseCategory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${formValues.department_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourseCategories(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourseCategory();
  }, [formValues.department_id]);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        // console.log("course category id: ", formValues);

        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${formValues.department_id}/${formValues.courseCategory_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourse(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourse();
  }, [formValues.courseCategory_id, formValues.department_id]);
  useEffect(() => {
    const fetchChapters = async () => {
      try {
        const token = localStorage.getItem("token");
        const dep_id = formValues.department_id;
        // console.log("department id-----------: ", dep_id);

        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-chapters/${dep_id}/${formValues.courseCategory_id}/${formValues.course_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setChapter(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchChapters();
  }, [
    formValues.courseCategory_id,
    formValues.department_id,
    formValues.course_id,
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        // navigate("/login"); // Redirect to login if no token
        return;
      }

      const reqBody = {
        department_id: formValues.department_id,
        courseCategory_id: formValues.courseCategory_id,
        course_id: formValues.course_id,
        chapter_id: formValues.chapter_id,
        unitname: formValues.unitname,
      };

      if (departmentToEdit) {
        // const response = await updateStudent(studentToEdit._id, reqBody, reqHeader);
        const response = await axios.put(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-unit/${departmentToEdit._id}`,
          reqBody,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          setSnackbarMessage("Updated successfully!");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
          setTimeout(() => {
            navigate("/unit-list");
          }, 2000);
        }
        // // console.log("edit: ", response);
      }

      //   navigate("/students");
    } catch (err) {
      console.error("Error updating user:", err);
      setError("Failed to update. Please try again");
      setSnackbarMessage("Failed to update. Please try again");
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={(e) => handleSubmit(e)}>
              <div className="mb-20">
                <div className="d-flex justify-content-end mb-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() =>
                      navigate(`/unitplans-edit/${departmentToEdit._id}`)
                    }
                  >
                    Edit Unit Plans
                  </button>
                </div>
                {/* {JSON.stringify(formValues)} */}
                <label
                  htmlFor="depart"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="depart"
                  value={formValues.department_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      chapter_id: "",
                      courseCategory_id: "",
                      course_id: "",
                      department_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments.map((department) => (
                    <option key={department._id} value={department._id}>
                      {department.department_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Level
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={formValues.courseCategory_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      chapter_id: "",
                      course_id: "",
                      courseCategory_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select Level
                  </option>
                  {courseCategories.map((courseCategory) => (
                    <option key={courseCategory._id} value={courseCategory._id}>
                      {courseCategory.courseCategoryName}
                    </option>
                  ))}
                </select>
              </div>

              {/* courseid */}
              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={formValues.course_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      chapter_id: "",
                      course_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a course
                  </option>
                  {course.map((courses) => (
                    <option key={courses._id} value={courses._id}>
                      {courses.coursename}
                    </option>
                  ))}
                </select>
              </div>
              {/* chapter id */}
              <div className="mb-20">
                <label
                  htmlFor="chapter"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Chapter
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="chapter"
                  value={formValues.chapter_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      chapter_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a chapter
                  </option>
                  {chapter.map((chapter) => (
                    <option key={chapter._id} value={chapter._id}>
                      {chapter.chaptername}
                    </option>
                  ))}
                </select>
              </div>
              {/* Unit Name */}
              <div className="mb-20">
                <label
                  htmlFor="unitname"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Unit Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  id="unitname"
                  placeholder="Enter unit name"
                  className="form-control radius-8"
                  value={formValues.unitname}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow empty value but prevent spaces-only input
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        unitname: value,
                      });
                    }
                  }}
                  required
                />
              </div>

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/unit-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditUnit;
